import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import AuthenticationApi from '../api/AuthenticationApi';

export default {
  login(user) {
    AuthenticationApi.login(user);
  },

  logout() {
    AuthenticationApi.logout();
  },

  authenticationChanged() {
    AppDispatcher.dispatch({
      actionType: ActionTypes.AUTHENTICATION_CHANGED,
    });
  }
};
